import React from 'react';
import classnames from 'classnames';
import Link from '@components/link';
import { observer } from 'mobx-react-lite';
import Icon from '@components/icon';
import * as styles from './Filter.scss';
import GeoSearch from '../GeoSearch';
import CheckSelect from '../CheckSelect';
import * as Filters from '../FilterIcons';
import FilterDirection from '../FilterDirection';
import GroupSelect from '../GroupSelect';
import strings from '../../strings';

const {
  AtiDocIcon,
  AutoparkIcon,
  ConfirmedContactsIcon,
  OrdersIcon,
  VerifiedProfileIcon,
  EpdMedalIcon,
} = Filters;

const FilterMobile = (props) => {
  const {
    verified,
    autopark,
    atiOrders,
    atiDocs,
    confirmedContacts,
    epdMedal,
    handleVerifiedClick,
    handleAutoparkClick,
    handleAtiOrdersClick,
    handleAtiDocsClick,
    handleConfirmedContactsClick,
    handleEpdMedalClick,
    firmTypeAbbreviation,
    showAllFilters,
    setShowAllFilters,
  } = props;

  const filtersCount = Object.keys(Filters).length;

  return (
    <div
      className={styles.filter}
    >
      <FilterDirection />
      <div className={styles.filtersContainer}>
        <div className={styles.geoSearchContainer}>
          <GeoSearch />
        </div>
        <GroupSelect />
        <CheckSelect />
      </div>

      {showAllFilters && (
        <div className={classnames(styles.filterRow, styles.filterRow__second)}>
          <VerifiedProfileIcon
            firmTypeAbbreviation={firmTypeAbbreviation}
            verified={verified}
            handleVerifiedClick={handleVerifiedClick}
          />
          <AutoparkIcon
            autopark={autopark}
            handleAutoparkClick={handleAutoparkClick}
          />
          <OrdersIcon
            atiOrders={atiOrders}
            handleAtiOrdersClick={handleAtiOrdersClick}
          />
          <AtiDocIcon
            atiDocs={atiDocs}
            handleAtiDocsClick={handleAtiDocsClick}
          />
          <ConfirmedContactsIcon
            confirmedContacts={confirmedContacts}
            handleConfirmedContactsClick={handleConfirmedContactsClick}
          />
          <EpdMedalIcon
            epdMedal={epdMedal}
            handleEpdMedalClick={handleEpdMedalClick}
          />
        </div>
      )}
      <Link
        as="button"
        onClick={() => setShowAllFilters(!showAllFilters)}
        className={styles.showAllFilters}
        theme="primary"
      >
        {showAllFilters ? strings.hideFilters : strings.showAllFilters} ({filtersCount})
        <Icon name={showAllFilters ? 'ic_arrow-up' : 'ic_arrow-down'} size="s" color="var(--glz-color-primary" />
      </Link>
    </div>
  );
};

export default observer(FilterMobile);
